/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_SecondsInputs */

const en_us2_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seconds per set`)
};

const pt_br2_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundos por série`)
};

const es_419_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundos por serie`)
};

const pt_pt2_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segundos por série`)
};

const fr_fr2_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondes par série`)
};

const de_de2_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekunden pro Satz`)
};

const it_it2_plan_build_dose_seconds = /** @type {(inputs: Plan_Build_Dose_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondi per serie`)
};

/**
* | output |
* | --- |
* | "Seconds per set" |
*
* @param {Plan_Build_Dose_SecondsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_seconds = /** @type {((inputs?: Plan_Build_Dose_SecondsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_SecondsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_seconds(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_seconds(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_seconds(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_seconds(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_seconds(inputs)
	return en_us2_plan_build_dose_seconds(inputs)
});
export { plan_build_dose_seconds as "plan-build.dose_seconds" }